import React from "react";

export const QuoteHeader = ({ heading, quote }) => (
	<div className="max-w-[980px] mx-auto text-center">
		<h1 className="t-subheading mb-4">{heading}</h1>
		<h2 className="t-52 font-medium" dangerouslySetInnerHTML={{ __html: quote }} />
	</div>
)